import {
  INITWEBSOCKET,
  NOTIFICATION_NEW,
  READNOTIFICATION
} from "constants/ActionTypes";

export const initWebsocket = (start, end) => {
  return {
    type: INITWEBSOCKET,
    payload: {
      start: start,
      end: end
    }
  };
};

export const readNotification = (email, id) => {
  return {
    type: READNOTIFICATION,
    payload: {
      email, id
    }
  };
};
